
export const LIST_TYPE_CAR = [
    { title: 'Frozen', value: "frozen" },
    { title: 'Cool', value: "cool" }
]

export const STATUS_ACTIVE = 'active';
export const STATUS_IN_ACTIVE = 'inactive';

export const STATUS_SUCCESS = 'success';
export const STATUS_CANCEL = 'cancel';
export const STATUS_READY = 'ready';

export const getStatusCarBadgeVariant = (status) => {
    switch (status) {
        case STATUS_ACTIVE:
        return { title: 'active', color: 'success'}
        case STATUS_IN_ACTIVE:
        return { title: 'inactive', color: 'dark'}
        default:
        return { title: '-', color: 'yellow'}
    }
}

export const getStatusBadgeVariant = (status) => {
    switch (status) {
        case "success":
        return "success";
        case "wait":
        return "dark";
        default:
        return "yellow";
    }
}

export const getStatusBadgeText = (status) => {
    switch (status) {
        case "success":
            return "เสร็จสิ้น";
        case "wait":
            return "รอดำเนินการ";
        default:
            return "กำลังดำเนินการ";
    }
}

export const TYPE_INVOICE = 'invoice';
export const TYPE_RECEIPT = 'receipt';
export const TYPE_QUOTATION = 'quotation';

export const TYPE_IMAGE_MILE = 'mile';
export const TYPE_IMAGE_INVOICE = 'invoice';
export const TYPE_IMAGE_PRODUCT = 'product';

export const getTypeimageRoute = (key) => {
    switch (key) {
        case TYPE_IMAGE_MILE:
        return { title: 'รูปไมล์เริ่มงาน'}
        case TYPE_IMAGE_INVOICE:
        return { title: 'Invoice'}
        case TYPE_IMAGE_PRODUCT:
        return { title: 'รูปสินค้า'}
        default:
        return { title: '-', color: 'yellow'}
    }
}
